import { init } from '@sentry/browser';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

createApp(App).use(router).mount('#app')

init({
  dsn: 'https://f477c35422ed47769f8d480b911d901e@o220965.ingest.sentry.io/5564101',
});
